module.exports = __webpack_public_path__ + "static/media/5.b09b2c4e.png";